/*
*     Customizable Modal Dialog to select a person from a tree.
*
*     The following are required javascript variables to be set up by the container page.
*     v_uid             user id
*     v_tid             tree id
*
*/

if (typeof TGN == "undefined") {
    var TGN = {};
}
TGN.namespace = function () {
    var a = arguments, o = null, i, j, d;
    for (i = 0; i < a.length; i++) {
        d = a[i].split(".");
        o = TGN;
        // TGN is implied, so it is ignored if it is included
        for (j = (d[0] == "TGN") ? 1 : 0; j < d.length; j++) {
            o[d[j]] = o[d[j]] || {};
            o = o[d[j]];
        }
    }
    return o;
};

TGN.namespace('TGN.Ancestry.Search.selectPerson');
$sp = TGN.Ancestry.Search.selectPerson;

function attachToPerson(tid, pid){
    var o = {
        url: v_spTreesUrlPrefix + "/pt/AttachStree.aspx?"+ v_spBrowseArgs + "&act=set",
        Name: "tid=",
        Value: tid
    };
    addParam(o);
    o.Name = "pid=";
    o.Value = pid;
    addParam(o);
    window.location.href = o.url;
}

function addParam(o){
    o.prevChar = "?";
    if (!replaceParam(o)) {
        o.prevChar = "&";
        if (!replaceParam(o)) {
            o.url += "&" + o.Name + o.Value;
        }
    }
}

function replaceParam(o){
    var Name = o.prevChar + o.Name;
    var paramStart = o.url.indexOf(Name);
    if (-1 != paramStart) {
        var paramEnd = o.url.indexOf("&", paramStart + Name.length);
        var curParam = o.url.substr(paramStart, paramEnd - paramStart);
        o.url = o.url.replace(curParam, Name + o.Value);
        return true;
    }
    return false;
}

TGN.Ancestry.Search.selectPerson.modalInit = function () {
    var sURL = "/Controls/LoadOnDemandSelectPerson_Responsive.aspx?userId=" + v_spUid + "&title=" + v_spTitle + "&message=" + v_spMessage + "&buttonText=" + v_spButtonText + "&tid=" + v_spTid + "&showTreeName=" + v_spShowTreeName + "&canSwitchTree=" + v_spCanSwitchTree;
    $.ajax({
        url: sURL,
        success: function(data){
            if(data){
                $sp.dialogInit(attachToPerson, data);
            } else{
                $sp.failGracefully(3);
            }
        },
        error : function(){
            TGN.Ancestry.Search.selectPerson.failGracefully(4);
        },
        cache: false
    });
};

TGN.Ancestry.Search.selectPerson.failGracefully = function (failCode) {
    var sParams = "";
    if (v_spBrowseArgs && v_spBrowseArgs.length > 0) {
        sParams = v_spBrowseArgs;
    }
    else {
        if (v_spTid) {
            sParams += '&tid=' + v_spTid;
        }
        if (v_spDbid) {
            sParams += '&dbid=' + v_spDbid;
        }
        if (v_spRpid) {
            sParams += '&rpid=' + v_spRpid;
        }
    }
    document.location.href = v_spTreesUrlPrefix + "/pt/AttachStree.aspx?" + sParams + "&failCode=" + failCode;
};

TGN.Ancestry.Search.selectPerson.clearSelection = function () {
    $("#typeAheadSelectPersonText").val("");
    $("#typeAheadSelectPersonPid").val("");
    $("#typeAheadSelectPersonDate").val("");
};

TGN.Ancestry.Search.selectPerson.dialogInit = function (actionCallback, html) {
    //Generate Modal JS code 
    //Params: id, width (width of modal), title (which shows as the title on the modal, empty string for none)
    var modalTitle = (typeof v_spTitle != 'undefined') ? decodeURIComponent(v_spTitle) : '';
    modalTitle = modalTitle.replace(/\+/gi, ' ');
    $("<div id='selectPersonModal'><div id='selectPersonModalContent'></div></div>").modal({
        hideCloseBtn: false,
        closeOnBkgClick: true,
        closeOnEscape: true,
        showLoading: false,
        width: 500,
        title: modalTitle,
        onOpen: function() {
            $('#selectPersonModalContent').html(html);
        }
    });

    //Show modal div
    $('#selectModal').show();

    ////Set title
    $('#modalHeader').text(modalTitle);
    $('#modalHeader').show();

    //Setup the Type Ahead Functionality
    $sp.typeAheadSetup();

    $("#actionButtonSelectModal").on('click', $sp.takeAction);
    $("#typeAheadSelectPersonText").focus();

    //Resets selected tree, basically to the first default one in the list everytime the modal is open
    //since the dropdownlist defaults to the first tree, if we don't do this, then we 
    //will run into issues where the previously selected tree is cached and opening the modal again defaults to the first tree but really
    //the previously selected tree is being used
    $sp.changeTreeSTDDL();
};

TGN.Ancestry.Search.selectPerson.convertXmlToJson = function(node){

    var	data = {};
    
    // append a value
    function Add(name, value) {
        if (data[name]) {
            if (data[name].constructor != Array) {
                data[name] = [data[name]];
            }
            data[name][data[name].length] = value;
        }
        else {
            data[name] = value;
        }
    };	
    
    // element attributes
    var c, cn;
    for (c = 0; c < node.attributes.length; c++) {
        cn = node.attributes[c];
        Add(cn.name, cn.value);
    }	
    
    // child elements
    for (c = 0; c < node.childNodes.length; c++) {
        cn = node.childNodes[c];
        if (cn.nodeType == 1) {
            if (cn.childNodes.length == 0){
                Add(cn.nodeName, cn.textContent);
            }
            else if (cn.childNodes.length == 1 && cn.firstChild.nodeType == 3) {
                // text value
                Add(cn.nodeName, cn.firstChild.nodeValue);
            }
            else {
                // sub-object
                Add(cn.nodeName, TGN.Ancestry.Search.selectPerson.convertXmlToJson(cn));
            }
        }
    }	
    return data;
};

TGN.Ancestry.Search.selectPerson.takeAction = function () {
    var pid = $("#typeAheadSelectPersonPid").val();
    if (pid.length > 0) {
        attachToPerson(v_spTid, pid);
        $sp.clearSelection();
        $.modal.close();
    }
    else {
        alert(rs_pleaseSelectPerson);
    }
};

TGN.Ancestry.Search.selectPerson.CancelSelectModal = function () {
    $sp.clearSelection();
    $.modal.close();
};

TGN.Ancestry.Search.selectPerson.autoSuggestBox;
TGN.Ancestry.Search.selectPerson.typeAheadSetup = function () {
    if ($("#typeAheadSelectPersonText")[0] != null) {
        $("#typeAheadSelectPersonText").autocomplete({
            source: "/handler/AutoSuggestionsHandler.ashx?NoUcdmRedir=1&ver="+ new Date().getTime() + "&uid=" + v_spUid + "&tid=" + v_spTid + "&type=name",
            minLength: 3,
            maxResults: 20,
            dataType: 'xml',
            key: 'name',
            queryParameter: 'inp',
            jsonConversion: function (data) {
                /* Custom Conversion Function */
                var response = TGN.Ancestry.Search.selectPerson.convertXmlToJson(data.documentElement);
                
                if (typeof response.suggestion.name !== "undefined") {
                    if (!response.suggestion.name && !response.suggestion.date && !response.suggestion.pid) {
                        return "";
                    }
                    response.suggestion = [response.suggestion];
                }
                
                for (var i = 0; i < response.suggestion.length; i++){
                    response.suggestion[i].name = response.suggestion[i].name.replace(/\$\[;/gi, "").replace(/\$\];/gi, "");
                }
                
                return response.suggestion;
            },
            customDisplay: function (data) {
                return { "display": data.value + " " + data.raw.date, "value": TGN.Ancestry.Search.decodeHtml(data.value) };
            },
            onItemSelect: function(itemData) {
                $("#typeAheadSelectPersonPid").val(itemData.pid);
                $("#typeAheadSelectPersonDate").val(itemData.date);
                $("#typeAheadSelectPersonText").on("change", $sp.clearSelection);
            }
        });
    }
};

TGN.Ancestry.Search.decodeHtml = function(value) {
    return $("<div/>").html(value).text();
};

TGN.Ancestry.Search.selectPerson.typeAheadUpdate = function (tid) {
    $sp.typeAheadSetup();
};

TGN.Ancestry.Search.selectPerson.changeTreeSTDDL = function () {
    //Update TypeAhead
    var tid = $("#selectTreeDropDown").val();
    v_spTid = tid;
    $("#typeAheadSelectPersonText").val("");
    $("#typeAheadSelectPersonPid").val("");
    $("#typeAheadSelectPersonDate").val("");
    $sp.typeAheadUpdate(tid);

    //Check Add person link. We won't show unless the person can edit a tree
    var display = ($("#selectTreeDropDown option:selected").attr("rights") != "True") ? 'none' : 'block';
    $("#addNewPersonLink").css("display", display);
};

TGN.Ancestry.Search.selectPerson.addNewPerson = function (dbid, rpid, oid) {
    var args = "";
    if (v_spDbid.length > 0) { args = args + "&dbid=" + v_spDbid; }
    if (v_spRpid.length > 0) { args = args + "&rpid=" + v_spRpid; }
    var url = v_spTreesUrlPrefix + "/pt/AddPerson.aspx?tid=" + v_spTid + args;
    window.location.href = url;
};

TGN.Ancestry.Search.selectPerson.gotoSelectList = function () {
    if (v_spBrowseArgs.length > 0) {
        var i, c;
        var tidLoc = v_spBrowseArgs.indexOf('_t');
        if (tidLoc > 0) {
            // find the length of the tid in the original url args
            for (i = tidLoc + 2; i < v_spBrowseArgs.length; i++) {
                c = v_spBrowseArgs.charAt(i);
                if ((c < "0" || c > "9") && c != "-") { break; }
            }
            // replace the original tid with the updated one in case the user has changed which tree to save to
            // but first save the original tid into a different arg
            var retTid = v_spBrowseArgs.substring(tidLoc + 2, i);
            v_spBrowseArgs = v_spBrowseArgs.substring(0, tidLoc + 2) + v_spTid + v_spBrowseArgs.substring(i) + "&stid=" + retTid;
        }
        var pidLoc = v_spBrowseArgs.indexOf('_p');
        if (pidLoc > 0) {
            // find the length of the pid in the original url args
            for (i = pidLoc + 2; i < v_spBrowseArgs.length; i++) {
                c = v_spBrowseArgs.charAt(i);
                if ((c < "0" || c > "9") && c != "-") { break; }
            }
            // remove the original pid, it serves no purpose here, the user is saving to another tree
            // but first save the original pid into a different arg
            var retPid = v_spBrowseArgs.substring(pidLoc + 2, i);
            v_spBrowseArgs = v_spBrowseArgs.substring(0, pidLoc) + v_spBrowseArgs.substring(i) + "&spid=" + retPid;
        }
        if (v_spTid !== null && v_spTid !== "") {
            v_spBrowseArgs += "&tid=" + v_spTid;
        }
        var url = v_spTreesUrlPrefix + "/pt/AttachStree.aspx?" + unescape(v_spBrowseArgs);
        window.location = url;
    } else {
        $sp.selectFromList(v_spTid);
    }
};

TGN.Ancestry.Search.selectPerson.setTreeId = function (tid) {
    v_spTid = tid;
};

TGN.Ancestry.Search.selectPerson.selectFromList = function (tid) {
    var url = v_spTreesUrlPrefix + "/pt/BrowseList.aspx?tid=" + tid;
    window.open(url, '', 'toolbar=no,resizable=yes,scrollbars=yes,menubar=no,status=no,location=no,height=550,width=800', true);
};